/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1PersonIdAddressesMutationRequest,
  PostApiV1PersonIdAddressesMutationResponse,
  PostApiV1PersonIdAddressesPathParams,
  PostApiV1PersonIdAddresses400,
  PostApiV1PersonIdAddresses401,
  PostApiV1PersonIdAddresses404,
  PostApiV1PersonIdAddresses409,
  PostApiV1PersonIdAddresses500,
} from "../../types/personRegisterController/PostApiV1PersonIdAddresses.ts";

function getPostApiV1PersonIdAddressesUrl(
  id: PostApiV1PersonIdAddressesPathParams["id"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/person/${id}/addresses` as const,
  };
  return res;
}

/**
 * @description Cria um novo endereço vinculado à pessoa. Não permite dois endereços do mesmo tipo. **(Requer Authorization para autenticação)**
 * @summary Criar endereço da pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/addresses}
 */
export async function postApiV1PersonIdAddresses(
  id: PostApiV1PersonIdAddressesPathParams["id"],
  data?: PostApiV1PersonIdAddressesMutationRequest,
  config: Partial<RequestConfig<PostApiV1PersonIdAddressesMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1PersonIdAddressesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1PersonIdAddresses400
      | PostApiV1PersonIdAddresses401
      | PostApiV1PersonIdAddresses404
      | PostApiV1PersonIdAddresses409
      | PostApiV1PersonIdAddresses500
    >,
    PostApiV1PersonIdAddressesMutationRequest
  >({
    method: "POST",
    url: getPostApiV1PersonIdAddressesUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
